import React from 'react';
import Header from '../../components/header';
import BusinessDetailsBody from './body';
import Footer from '../../components/footer';

function BusinessDetails() {
    return (
        <div>
            <Header></Header>
            <BusinessDetailsBody></BusinessDetailsBody>
            <Footer></Footer>
        </div>
    );
}

export default BusinessDetails;